import { episodeOfCareAction } from 'src/redux/actions/constant';

const {
  CREATE_EPISODE_OF_CARE_FAILURE,
  CREATE_EPISODE_OF_CARE_SUCCESS,
  RESET_CREATE_EPISODE_OF_CARE,
  CREATE_EPISODE_OF_CARE_LOADING,
} = episodeOfCareAction;

const intitialstate: object = {
  isCreated: false,
  response: null,
  loading: false,
};

export const createEpisodeOfCareReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case CREATE_EPISODE_OF_CARE_SUCCESS: {
      return {
        ...state,
        isCreated: true,
        response: action.payload,
        loading: false,
      };
    }

    case CREATE_EPISODE_OF_CARE_FAILURE:
      return {
        ...state,
        isCreated: false,
        response: action.payload,
        loading: false,
      };

    case CREATE_EPISODE_OF_CARE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case RESET_CREATE_EPISODE_OF_CARE:
      return intitialstate;

    default:
      return state;
  }
};
